import { messagePostDescription as description } from './description';
import { post as execute } from './execute';

export { description, execute };
